export const SUGGESTION = "suggestion";
export const NEW = "new";

export const prepareTaskPayload = (tasks, taskListId) => {
  const tasksArray = [];
  Object.values(tasks)
    .sort((a, b) => a.position - b.position)
    .forEach((task) => {
      if (task?.name) {
        tasksArray[tasksArray.length] = {
          name: task.name,
          assignee_id: task.assignee_id,
          start_on: task.start_on,
          due_on: task.due_on,
          task_list_id: taskListId,
          estimate: task.estimate,
          job_type_id: task.job_type_id,
        };
      }
    });
  return tasksArray;
};

export const prepareSubtaskPayload = (subtasks) => {
  const subtasksArray = [];
  Object.values(subtasks)
    .sort((a, b) => a.position - b.position)
    .forEach((subtask) => {
      if (subtask?.name) {
        subtasksArray[subtasksArray.length] = {
          body: subtask.name,
          assignee_id: subtask.assignee_id,
          due_on: subtask.due_on,
        };
      }
    });
  return subtasksArray;
};
